<div class="blackshield" *ngIf="show"></div>

<div fxLayoutAlign="center center" *ngIf="show">
  <mat-card class="overshield" fxLayoutAlign="center center">
    <mat-card-content fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%">
      <span>{{ message || 'CORE.OVERLAY.LOADING' | translate}}</span>
      <mat-spinner diameter="40"></mat-spinner>
    </mat-card-content>
  </mat-card>
</div>
